module.exports = __webpack_public_path__ + "img/therapy.ab58023f.svg";